
import {
validateDiscountPromotion,
addCart,
getGoodDetail,
orderNewOrder,
newOrderPre,
newOrderSave
} from "@/api/goodDetails"
import {
chkLogin
} from "@/api/login"
import {
getCookie
} from "@/utils/auth.js";
import {
setCookie
} from "@/utils/cookie"
import Calendar from "../calendar"; 
import Alert from 'vux/src/components/alert/index.vue'

import {
Toast
} from 'vant';
import { mapState } from 'vuex';
export default {
name: 'specsLayer',

data() {
return {
ladderPrices: [], //订阅多久
introduceText: "", //周期描述
showCal: false, //日历展示状态
nextstepdisbaled: false, //是否售罄
skus0: [],
skuTotalPrice: 0,
oldSkuTotalPrice: 0,
showMoreTime: false,
s_getDateType: "", //选中的商品类型
currentTime: 0, //当前时间
cur: "",
extraList: [],
showExtraList: [], //展示的换购商品
giftList: [],
showGiftList: [], //展示的赠品商品
greenFirst: "", //日历时间
presellDate: "", //预售时间

currentindex: 0, //当前选中的订阅时间
ruleSkuesArr: [], //多规格
ruleSkuesArrout: [],
monycheckitem: null,
standard: false,
discountList: [],
deliveryPeriodList: [], //收花频次
defultDeliveryPeriod: "",
frequencyCheckcurrent: 0, //选中的收花频次
checkSpecsIndex: 0, //非周期 选中规格
gbid: null, //参团
showDtimes: [], //显示收货时间
noSaleableTime: false, //是否可以点击下一步
receiveType: null, //收货类型
getFlowerDate: "", //收货时间
isAppointDate: '',//是否指定收花日期
beforeExtraPrice: 0, //加购前的价格
beforeOldExtraPrice: 0, //加购前的价格
textPrice: "", //切换周期价格描述
checkAutoPrice: "", //切换周期价格描述
autoPrice: "", //切换周期价格描述
depositPrice: "", //定金
depositTotalPrice: 0, //定金总价
isMsg: 0, //是否有电子祝福卡
cids: {
9: "包月鲜花",
10: "包月鲜花",
11: "鲜花超市",
12: "鲜花超市",
13: "绿植",
14: "绿植",
15: "礼品鲜花",
16: "礼品鲜花",
17: "花器周边",
18: "花器周边",
19: "节日限定",
20: "节日限定",
21: "活动配置",
22: "活动配置",
23: "其他",
24: "其他",
}, //转化cid商品类目
single_goods_activity_id: "",
single_goods_activity_name: "",
activity_type: "",
specifications_name: "",
spec_name: "",
s_getFlowerDate: "",
moreObj: {},
s_skuId: "",//选中的skuid
haveAppointment: false,
extraGoodsPrice: 0, //换购商品总价
newOrderPreData: {}, //
settlementOpen: false,//价格明细
showCoupon: false,//显示优惠券

shoppingVoucher: 0,//购物金抵扣
shipmentFee: 0, //运费
couponDiscountFee: 0,//优惠券抵扣金额
actualCouponDiscountFee: 0,//优惠券实际抵扣金额
goodsQuantity: 0,//商品数量
coupons: [],//优惠券列表
subBtnDisabled : false,//立即支付按钮
canShipment : 0,//0:不可配送 1:可配送, 2:无地址
mayCanPayment: false, //可以立即支付状态
}
},
computed: {
...mapState(['addressObj', 'goodsInfo', 'checkExtraList']),

actualPrice() {
console.log(this.skuTotalPrice,this.shoppingVoucher,this.shipmentFee,this.couponDiscountFee,'====>')
return Math.abs(parseFloat(this.skuTotalPrice) - parseFloat(this.shoppingVoucher) + parseFloat(this.shipmentFee) - parseFloat(this.actualCouponDiscountFee)).toFixed(2)

}
},
components: {
Calendar,
Alert,
[Toast.name]: Toast
},
props: {
goodInfo: {
type: Object,
value: null,
},
minLadderPrice: {
type: Object,
value: null,
},
goods: {
type: Object,
value: null,
},
staticDomain: {
type: String,
value: "",
},
imgDomian: {
type: String,
value: "",
},
nowDate: {
type: Number,
value: 0,
},
dtimes: {
type: Array,
value: [],
},
cIsNew: {
type: Number,
value: -1,
},
weChat: {
type: Boolean,
value: false,
},
cartFlag: {
type: Number,
value: false,
},
saleableTime2Extra: {
type: String,
value: "",
}, //换购时间
saleableTime2ExtraExist: {
type: Boolean,
value: false,
},
saleableTime2Gift: {
type: String,
value: "",
},
saleableTime2GiftExist: {
type: Boolean,
value: false,
},
gid: {
type: Number,
value: 0,
},
isAuto: {
type: String,
value: "",
},
jionGroup: {
type: Boolean,
value: false,
},
isGift: {
type: Boolean,
value: false,
},
headPrice: {
type: Boolean,
value: false,
},
type: {
type: Number,
value: -1,
},
vgid: {
type: String,
value: "",
},
excludeCycleTime: {
type: Object,
value: {},
}, //eskuId 和屏蔽周期时间
buy_way: {
type: String,
value: "",
},
utm_source: {
type: String,
value: "",
},
gidciphertext: {
type: String,
value: "",
},
},
methods: {
splitFun: function (str, sign, num) {
if (str != undefined) {
str = str.toString();
let arr = str.split(sign);
if (arr.length > num) {
return arr[num];
} else {
return "00";
}
}
return "";
},
strLengthFun: function (str) {
if (str != undefined) {
let num = str.length;
return num;
}
return 0;
},
getTotalPrice: function (price, num) {
var total = 1;
if (price != null && price != "" && num != null && num != "") {
total = price * num;
}
return ((total.toString()).indexOf(".") > 0) ? total.toFixed(2) : total;
},

openshowClenderFun: function () {
this.showCal = true;
this.$forceUpdate();
},

closeClenderFun: function () {
this.showCal = false;
this.$forceUpdate();
},

ongetValidDates: function (e) {
var cal_num_arr = [];
console.log(e, 'eee')
for (var i = 0; i < e.detail.out_data.length; i++) {
var year = e.detail.out_data[i].getFullYear();
var day = e.detail.out_data[i].getDate();
var mou = e.detail.out_data[i].getMonth() + 1;
var week = e.detail.out_data[i].getDay();
if (day < 10) {
day = '0' + day;
} else {
day = day;
};
if (mou < 10) {
mou = '0' + mou
} else {
mou = mou;
};
var weekArray = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
for (var k = 0; k < 7; k++) {
if (week == k) {

week = weekArray[k];
}
}
var data_string = mou + '-' + day + '' + week;
var alldata_string = year + '-' + mou + '-' + day;
var item = {};
item.data = data_string;
item.allday = alldata_string
if (i == 0) {
item.check = true;
} else {
item.check = false;
}

cal_num_arr.push(item)
}
this.setData({
cal_num: cal_num_arr,
cal_num_len: cal_num_arr.length
})

let timesArr = []
console.log(this.data.productData, 'productData')
if (this.data.productData) {
if (this.data.productData.goods.getDateType == 14) {
let times = this.showDtimes
times.map((item, index) => {
let obj = {}
obj.check = false
obj.data = item.showDate + item.week
obj.allday = item.date
if (index == 0) {
obj.check = true
}
if (timesArr.length < 3) {
timesArr.push(obj)
}
})
this.cal_num = timesArr;
this.cal_num_len = timesArr.length;
}
}

console.log(cal_num_arr, ' cal_num_arr')
},
onselDate: function (datestr) {
this.showCal = false;

if (datestr) {
var datestr2 = datestr.slice(5);
var datestr3 = datestr.substring(0, datestr.length - 2)
var datestrobj = {
date: datestr3,
week: datestr2,
check: true
};
var datestrArr = [];
datestrArr.push(datestrobj);

this.showMoreTime = true;
this.showDtimes = datestrArr;
this.$forceUpdate();
}

},

submitNextFun: function () {
console.log("下一步")
let that = this;
if (that.noSaleableTime) {
return;
}
let uid = getCookie("hdu");
let hdt = getCookie("hdt");
if (!!!uid || !!!hdt) {
chkLogin();
return;
}
if (!!!this.s_skuId) {
this.$vux.toast.text('请选择购买商品或规格', 'middle');
return;
}



for (let t = 0; t < this.showDtimes.length; t++) {
if (this.showDtimes[t]["check"]) {
this.s_getFlowerDate = this.showDtimes[t].date;
break;
}
}

var extraGoods = [];
var have_exchange_goods = this.showExtraList.length > 0 ? true : false;
var exchange_goods_id = [];
var exchange_goods_name = [];
for (let i = 0; i < this.showExtraList.length; i++) {
if (this.showExtraList[i].check) {
extraGoods.push({
"pid": this.showExtraList[i].aid,
"skuId": this.showExtraList[i].skuId
});
exchange_goods_id.push(this.showExtraList[i].aid);
exchange_goods_name.push(this.showExtraList[i].displayName)
}
}

if (this.cartFlag == 1 && !this.isAuto) {


if (this.isAuto) {
this.$vux.toast.text('没有可选订阅周期', 'middle');
return;
}

let tempArr = [];
let transArr = [];
for (let i = 0; i < extraGoods.length; i++) {
if (tempArr.indexOf(extraGoods[i].pid) === -1) {
transArr.push({
pid: extraGoods[i].pid,
skus: [extraGoods[i].skuId],
type: 1
});
tempArr.push(extraGoods[i].pid);
} else {
for (let j = 0; j < transArr.length; j++) {
if (transArr[j].pid == extraGoods[i].pid) {
transArr[j].skus.push(extraGoods[i].skuId);
break;
}
}
}
}
console.log("transArr------", transArr)


var params = {
"spuId": 0,
"skuId": this.s_skuId,
"utmFrom": this.utm_source,
"interval": this.defultDeliveryPeriod,
"receiveDate": this.s_getFlowerDate,
"promotions": transArr,
};

if (this.goods.isCycle) {
params.periodsNum = this.s_sendNumber;
}

addCart(params).then(res => {
if (res.code == 1) {
this.showCal = false;
this.$vux.toast.text('加入购物车成功', 'middle');
this.$emit("getViewCartShopNumFun", null); 
}
})
} else {



var giftGoods = [];
var have_gifts = this.showGiftList.length > 0 ? true : false;
var gift_id = [];
var gift_name = [];
for (let i = 0; i < this.showGiftList.length; i++) {
if (this.showGiftList[i].check) {
giftGoods.push({
"pid": this.showGiftList[i].aid,
"skuId": this.showGiftList[i].skuId
});
gift_id.push(this.showGiftList[i].aid);
gift_name.push(this.showGiftList[i].displayName);
}
}




let skuId = this.s_skuId; 
let skuLadderPriceId = this.s_skuLadderPriceId; 
let sendNumber = this.s_sendNumber; 
let getDateType = this.goods.getDateType;
let getFlowerDate = this.s_getFlowerDate; 
let deliveryPeriod = this.defultDeliveryPeriod; 
let closeTime = this.goods.closeTime;
let type = this.type == 30 ? 3 : this.type;
let isMsg = this.isMsg; 
let isAuto = this.isAuto == undefined ? 0 : this.isAuto; 
let number = this.s_number;
let aid = "";
let gdt_vid = "";


if (isAuto == 1) {
type = 0;
}



let discountGoods = [{
pid: this.goodInfo.discountPromId,
skuId: this.s_skuId
}]; //折扣商品



sa.track("SelectSpecs", {
platform_type: "H5",
utm_source: this.utm_source,
referrer: document.referrer, // 前向地址
product_id: this.goods.gid, // 商品编号
product_name: this.goods.title, // 商品标题
product_subtitle: this.goods.subtitle, // 商品副标题
product_price: this.skuTotalPrice,
product_quantity: 1, //商品数量
product_type: this.cids[this.goods.cid], // 一级分类
buy_way: this.buy_way,
spec_name: this.spec_name,
send_number: sendNumber,
is_auto: isAuto == 0 ? false : true,
content_source: 1, //立即购买
sku_id: skuId, //商品skuid
have_gifts: have_gifts, //是否有赠品
gift_id: gift_id, //赠品id
gift_name: gift_name, //赠品名称
have_exchange_goods: have_exchange_goods, //是否换购
exchange_goods_id: exchange_goods_id, //换购id
exchange_goods_name: exchange_goods_name, //换购名称
receiving_time: this.s_getFlowerDate != "" ? this.s_getFlowerDate : null, //所选首次收货时间
specifications_name: this.specifications_name, //所选规格名称

single_goods_activity_id: this.single_goods_activity_id,

single_goods_activity_name: this.single_goods_activity_name,

goods_activity_id: [],

goods_activity_name: [],

activity_type: this.activity_type,
});




if (this.goods.goodsExt.moreAddr && this.goodInfo.displayType != 103) {
let moreObj = {
gidciphertext: this.gidciphertext,
gid: this.goods.gid,
extraGoods: JSON.stringify(extraGoods),
giftGoods: JSON.stringify(giftGoods),
skuId: skuId,
skuLadderPriceId: skuLadderPriceId,
number: number,
getDateType: getDateType,
getFlowerDate: getFlowerDate,
deliveryPeriod: deliveryPeriod,
closeTime: closeTime,
isMsg: isMsg,
isAuto: isAuto,
type: type,
sendNumber: sendNumber,
aid: aid,
gdt_vid: gdt_vid,
moreAddrDesc: this.goods.goodsExt.moreAddrDesc
}



if (type != 0) {
moreObj.discountGoods = JSON.stringify(discountGoods);
}


if (this.goodInfo.displayType == 103) {
moreObj.gbpId = this.gbpId;

if (this.jionGroup) {
moreObj.gbId = this.gbid;
}


if (this.headPrice) {
moreObj.isGroup = 0;
} else {
moreObj.isGroup = 1;
}
}




this.$router.push({
path: '/MoreAddrOrder',
query: moreObj
})
} else {
let url = "";
if (!this.isGift) {
url = process.env.API + "/order/newOrder"; 
} else {
url = process.env.API + "/gorder/newOrder"; 
}


var form = document.createElement("form");
document.body.appendChild(form);
var generateHideElement = function (name, value) {
var tempInput = document.createElement("input");
tempInput.type = "hidden";
tempInput.name = name;
tempInput.value = value;
return tempInput;
}
var gidInput = generateHideElement("gid", this.goods.pageUri);
form.appendChild(gidInput);
var extraGoodsInput = generateHideElement("extraGoods", JSON.stringify(extraGoods));
form.appendChild(extraGoodsInput);
var giftGoodsInput = generateHideElement("giftGoods", JSON.stringify(giftGoods));
form.appendChild(giftGoodsInput);
var skuIdInput = generateHideElement("skuId", skuId);
form.appendChild(skuIdInput);
var skuLadderPriceIdInput = generateHideElement("skuLadderPriceId", skuLadderPriceId);
form.appendChild(skuLadderPriceIdInput);
var numberInput = generateHideElement("number", number);
form.appendChild(numberInput);
var getDateTypeInput = generateHideElement("getDateType", getDateType);
form.appendChild(getDateTypeInput);
var getFlowerDateInput = generateHideElement("getFlowerDate", getFlowerDate);
form.appendChild(getFlowerDateInput);
var deliveryPeriodInput = generateHideElement("deliveryPeriod", deliveryPeriod);
form.appendChild(deliveryPeriodInput);
var closeTimeInput = generateHideElement("closeTime", closeTime);
form.appendChild(closeTimeInput);
var isMsgInput = generateHideElement("isMsg", isMsg);
form.appendChild(isMsgInput);
var isAutoInput = generateHideElement("isAuto", isAuto);
form.appendChild(isAutoInput);
var typeInput = generateHideElement("type", type);
form.appendChild(typeInput);
var sendNumberInput = generateHideElement("sendNumber", sendNumber);
form.appendChild(sendNumberInput);
var aidInput = generateHideElement("aid", aid);
form.appendChild(aidInput);
var gdt_vidInput = generateHideElement("gdt_vid", gdt_vid);
form.appendChild(gdt_vidInput);




if (type != 0) {
var discountGoodsInput = generateHideElement("discountGoods", JSON.stringify(discountGoods));
form.appendChild(discountGoodsInput);
}


if (this.goodInfo.displayType == 103) {
var gbpIdInput = generateHideElement("gbpId", this.gbpId);
form.appendChild(gbpIdInput);

if (this.jionGroup) {
var gbidInput = generateHideElement("gbId", this.gbid);
form.appendChild(gbidInput);
}


if (this.headPrice) {
var isGroupInput = generateHideElement("isGroup", 0);
form.appendChild(isGroupInput);
} else {
var isGroupInput = generateHideElement("isGroup", 1);
form.appendChild(isGroupInput);
}
}

form.method = "post";
form.action = encodeURI(url);
form.submit();


}





}
},

submitNewOrderFn() {
console.log("下一步")
let that = this;
if (that.noSaleableTime) {
return;
}
if (this.subBtnDisabled) {
return;
}
let uid = getCookie("hdu");
let hdt = getCookie("hdt");
sa.track("payment", {
platform_type: "H5",

});
if (!!!uid || !!!hdt) {
chkLogin();
return;
}
if (!!!this.s_skuId) {
this.$vux.toast.text('请选择购买商品或规格', 'middle');
return;
}
if(this.canShipment == 0){
this.$vux.toast.text('当前地址不可配送！', 'middle');
return
}else if(this.canShipment == 2){
this.$vux.toast.text('请选择配送地址！', 'middle');
return
}

sa.track("payment", {
platform_type: "H5",
});

for (let t = 0; t < this.showDtimes.length; t++) {
if (this.showDtimes[t]["check"]) {
this.s_getFlowerDate = this.showDtimes[t].date;
break;
}
}

var promotions = [];
let type = this.type == 30 ? 3 : this.type;

let tempArr = [];
let extraList = []
for (let i = 0; i < this.showExtraList.length; i++) {
if (this.showExtraList[i].check) {
if (tempArr.indexOf(this.showExtraList[i].aid) === -1) {
extraList.push({
type: 1,
skus: [this.showExtraList[i].skuId],
pid: this.showExtraList[i].aid
});
tempArr.push(this.showExtraList[i].aid);
} else {
for (let j = 0; j < extraList.length; j++) {
if (extraList[j].pid == this.showExtraList[i].aid) {
extraList[j].skus.push(this.showExtraList[i].skuId);
break;
}
}
}
}
}



let tempArrGift = [];
let giftList = []
for (let i = 0; i < this.showGiftList.length; i++) {
if (this.showGiftList[i].check) {
if (tempArrGift.indexOf(this.showGiftList[i].aid) === -1) {
giftList.push({
type: 3,
skus: [this.showGiftList[i].skuId],
pid: this.showGiftList[i].aid
});
tempArrGift.push(this.showGiftList[i].aid);
} else {
for (let j = 0; j < giftList.length; j++) {
if (giftList[j].pid == this.showGiftList[i].aid) {
giftList[j].skus.push(this.showGiftList[i].skuId);
break;
}
}
}
}

}
promotions = promotions.concat(giftList).concat(extraList)

if (this.goodInfo.displayType == 104) {
let discountObj = {
pid: this.goodInfo.discountPromId,
skus: [this.s_skuId],
type: 2
}
promotions.push(discountObj)
}

let nowsalePrice = this.subtr(this.skuTotalPrice, this.extraGoodsPrice)
let params = {
uid: uid,
code: this.goodsInfo.orderCode,
skuId: this.s_skuId,
spuId: this.goods.pageUri,
receiveDate: this.s_getFlowerDate === 0 ? '' : this.s_getFlowerDate,
addressId: this.newOrderPreData.address.uaId,
couponId: this.couponId, //优惠券编号
couponDiscountFee: this.actualCouponDiscountFee, //优惠券抵扣
salePrice: (parseFloat(nowsalePrice)).toFixed(2),//this.subtr(this.skuTotalPrice, this.extraGoodsPrice),//省略到小数点后两位
extraGoodsPrice: this.extraGoodsPrice,
shipmentFee: this.shipmentFee,
shoppingVoucher: this.shoppingVoucher, //购物金抵扣金额
type: type,
payMethod: "wx",
isSmart: 'N',
miniAppid: "",
from: "",
utm_source: this.utm_source,
promotions: promotions
}
this.subBtnDisabled = true
newOrderSave(params).then(res => {
if (res.code == 1) {
this.$vux.toast.text('订单生成中，请稍后', 'middle');
window.location.href = res.data
}else if(res.code ==4){
this.$vux.toast.text('订单生成中，请稍后', 'middle');
setTimeout(()=>{
this.subBtnDisabled = false
window.location.href = res.data
},2000)
} else {
this.subBtnDisabled = false
this.$vux.toast.text(res.desc, 'middle');

}
}).catch(err=>{
this.subBtnDisabled = false
})
},

settlementOpenFn() {
let goodsArr = []
for (let i = 0; i < this.showGiftList.length; i++) {
if (this.showGiftList[i].check) {
goodsArr.push(i)
}
}
for (let i = 0; i < this.showExtraList.length; i++) {
if (this.showExtraList[i].check) {
goodsArr.push(i)
}
}
this.goodsQuantity = goodsArr.length + 1
this.settlementOpen = !this.settlementOpen
},

changeCouponFun(index, couponItem) {

this.actualCouponDiscountFee = 0
if (couponItem.check == true) {
couponItem.check = false;
this.couponId = "";
let couponDiscountFee = this.couponDiscountFee
this.couponDiscountFee = 0
this.shoppingVoucher = 0;
console.log(couponDiscountFee,'couponDiscountFee',this.shoppingVoucher)
} else {
this.coupons.map(item => {
item.check = false
})
couponItem.check = true
this.couponId = couponItem.couponId;
this.couponDiscountFee = couponItem.value
}
let payMoney = this.subtr(this.skuTotalPrice, this.couponDiscountFee)
if(this.skuTotalPrice <= this.couponDiscountFee){
this.shoppingVoucher = 0;
this.actualCouponDiscountFee = this.skuTotalPrice
if(this.newOrderPreData.shoppingVoucher > this.shipmentFee){
this.shoppingVoucher = this.shipmentFee
}else{
this.shoppingVoucher = this.newOrderPreData.shoppingVoucher
}
}else{
if (this.addition(payMoney,this.shipmentFee)  > this.newOrderPreData.shoppingVoucher) {
this.shoppingVoucher = this.newOrderPreData.shoppingVoucher
} else {
this.shoppingVoucher = this.addition(payMoney,this.shipmentFee)
console.log(this.subtr(this.skuTotalPrice, this.couponDiscountFee), this.couponDiscountFee,'this.shoppingVoucher',this.shoppingVoucher)
}
this.actualCouponDiscountFee =  this.couponDiscountFee
}


},

goAddressList() {
let info = {
gid: this.$route.query.gid,
utm_source: this.$route.query.utm_source,
orderCode: this.newOrderPreData.code
}
this.$store.commit('SET_GOODSINFO', info)
this.$router.push({
path: '/addressList',
query: {
uaid: '',
type: 'goodDetails',
goodsType: 0,
tblId: this.goods.freightTplId
}
})
},

getNewOrderPre() {
let uaId = this.$route.query.uaid || "";
let code = this.goodsInfo.orderCode || "";
let supportCoupon = this.goodInfo.supportCoupon == null? true : this.goodInfo.supportCoupon
this.couponDiscountFee = 0;
this.coupons = [];
this.couponId = "";
this.shipmentFee = 0;
let params = {
uid: "",
spuId: this.goodInfo.goods.pageUri,
addressId: uaId,
supportCoupon: supportCoupon,
salePrice: this.skuTotalPrice,
extraGoodsPrice: this.extraGoodsPrice,
code: code
}
newOrderPre(params).then(res => {
if(res.code== 1){
let data = res.data
this.newOrderPreData = data
this.canShipment = data.canShipment
this.shipmentFee = data.shipmentFee
if (data.coupons!=null && data.coupons.length > 0) {
let maxValue = 0, couponId = "";

for (let i = 0; i < data.coupons.length; i++) {
this.$set(data.coupons[i], 'check', 'false')
if (data.coupons[i].value > maxValue) {
maxValue = data.coupons[i].value
couponId = data.coupons[i].couponId
this.$set(data.coupons[i], 'check', true)
}
}
this.couponDiscountFee = parseFloat(maxValue)
this.couponId = couponId
this.coupons = data.coupons
}


let payMoney = this.subtr(data.salePrice, this.couponDiscountFee)
if(data.salePrice <= this.couponDiscountFee){
this.shoppingVoucher = 0;
this.actualCouponDiscountFee =data.salePrice
if(data.shoppingVoucher > data.shipmentFee){
this.shoppingVoucher = data.shipmentFee
}else{
this.shoppingVoucher = data.shoppingVoucher
}
}else{
if (this.addition(payMoney,this.shipmentFee)  > data.shoppingVoucher) {
this.shoppingVoucher = data.shoppingVoucher
} else {
this.shoppingVoucher = this.addition(payMoney,this.shipmentFee)
}
this.actualCouponDiscountFee =  this.couponDiscountFee
}

if (!!!code) {
let obj = {
orderCode: data.code
}
this.$store.commit('SET_GOODSINFO', obj)
}
this.$store.commit('updateAddress', data.address)
}

})
},

getNumInteger(value) {
return Math.floor(value)
},

getNumDecimal(value) {

var intPart = Math.floor(value); 


var decimalPart = this.subtr(value, intPart)
if (decimalPart == 0) {
return '00'
}
if (decimalPart < 1) {
decimalPart = decimalPart * 100
}
return decimalPart
},

subtr(num1, num2) {
var r1, r2, m, n;
try { r1 = num1.toString().split(".")[1].length } catch (e) { r1 = 0 }
try { r2 = num2.toString().split(".")[1].length } catch (e) { r2 = 0 }
m = Math.pow(10, Math.max(r1, r2));
n = (r1 >= r2) ? r1 : r2;
return ((num1 * m - num2 * m) / m).toFixed(n);
},

addition: function(arg1, arg2) {
var r1, r2, m;
try {
r1 = arg1.toString().split(".")[1].length;
} catch (e) {
r1 = 0;
}
try {
r2 = arg2.toString().split(".")[1].length;
} catch (e) {
r2 = 0;
}
m = Math.pow(10, Math.max(r1, r2));
return (arg1 * m + arg2 * m) / m;
},


closeProductDetail: function () {
this.showProductDetail = false;
},

infoFun: function () {
let that = this;
that.getSingleGoodsActivityFun(that.goods)

if (this.goods.isCycle) {

that.minLadderPrice = that.getSkuMinPrice(that.goodInfo.ladderPrices);


let ladderPrices = that.goods.skus[0].skuLadderPrices.concat();
if (ladderPrices.length > 0) {


if (!ladderPrices[0].isAutoRenew) {
ladderPrices[0].check = true;
that.currentindex = 0;
that.spec_name = ladderPrices[0].name;
} else if (ladderPrices[0].isAutoRenew && this.weChat) {

if (that.isGift != true && that.goodInfo.displayType != 102 && that.goodInfo.displayType != 103) {
ladderPrices[0].check = true;
that.currentindex = 0;
that.spec_name = ladderPrices[0].name;
} else {
if (ladderPrices.length > 1) {
ladderPrices[1].check = true;
that.currentindex = 1;
that.spec_name = ladderPrices[1].name;
}
}
} else {
if (ladderPrices.length > 1) {
ladderPrices[1].check = true;
that.currentindex = 1;
that.spec_name = ladderPrices[1].name;
}
}
}



if (!ladderPrices[0].isAutoRenew || (ladderPrices[0].isAutoRenew && this.weChat && (this.isGift != true && that.goodInfo.displayType != 102 && that.goodInfo.displayType != 103))) {
that.s_skuId = ladderPrices[0].skuId;
that.s_skuLadderPriceId = ladderPrices[0].id;
that.s_sendNumber = ladderPrices[0].sendNumber;
that.s_number = ladderPrices[0].buyNumber;
that.isAuto = ladderPrices[0].isAutoRenew ? 1 : 0;

that.oldSkuTotalPrice = ladderPrices[0].marketPrice;
if (ladderPrices[0].autoRenewDiscountPrice != null) {
that.skuTotalPrice = (ladderPrices[0].autoRenewDiscountPrice * ladderPrices[0].sendNumber).toFixed(2);
} else {

if (that.goodInfo.displayType == 102) {
that.skuTotalPrice = (that.skus0.salePrice * ladderPrices[0].sendNumber).toFixed(2);
that.depositTotalPrice = that.getTotalPrice((that.skus0.extPrice + that.skus0.salePrice),
ladderPrices[0].sendNumber);
this.changeSendNumber((that.skus0.extPrice + that.skus0.salePrice).toFixed(2));
} else if (that.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[0].unitExtPrice, ladderPrices[0].sendNumber);
this.changeSendNumber(ladderPrices[0].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[0].salePrice;
this.changeSendNumber(ladderPrices[0].unitSalePrice.toFixed(2));
}
} else if (that.goodInfo.displayType == 103) {


if (this.headPrice) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[0].unitExtPrice, ladderPrices[0].sendNumber);
this.changeSendNumber(ladderPrices[0].unitExtPrice.toFixed(2));
} else {

if (this.type == 30) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[0].unitGroupBuyingPrice, ladderPrices[0]
.sendNumber);
this.changeSendNumber(ladderPrices[0].unitGroupBuyingPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[0].unitSalePrice * ladderPrices[0].sendNumber;
this.changeSendNumber(ladderPrices[0].unitSalePrice.toFixed(2));
}

}
} else {
if (ladderPrices[0].unitExtPrice != null) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[0].unitExtPrice, ladderPrices[0].sendNumber);
this.changeSendNumber(ladderPrices[0].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[0].salePrice;
this.changeSendNumber(ladderPrices[0].unitSalePrice.toFixed(2));
}
}

}
} else {
if (ladderPrices.length > 1) {
that.s_skuId = ladderPrices[1].skuId;
that.s_skuLadderPriceId = ladderPrices[1].id;
that.s_sendNumber = ladderPrices[1].sendNumber;
that.s_number = ladderPrices[1].buyNumber;
that.isAuto = ladderPrices[1].isAutoRenew ? 1 : 0;
that.skuTotalPrice = ladderPrices[1].salePrice;
that.oldSkuTotalPrice = ladderPrices[1].marketPrice;
if (ladderPrices[1].autoRenewDiscountPrice != null) {
that.skuTotalPrice = ladderPrices[1].autoRenewDiscountPrice;
} else {

if (that.goodInfo.displayType == 102) {
that.skuTotalPrice = (that.skus0.salePrice * ladderPrices[1].sendNumber).toFixed(2);



that.depositTotalPrice = that.getTotalPrice((this.skus0.extPrice + this.skus0.salePrice),
ladderPrices[1]
.sendNumber);
this.changeSendNumber((ladderPrices[1].extPrice + ladderPrices[1].salePrice).toFixed(2));
} else if (that.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[1].unitExtPrice, ladderPrices[1].sendNumber);
this.changeSendNumber(ladderPrices[1].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[1].salePrice;
this.changeSendNumber(ladderPrices[1].unitSalePrice.toFixed(2));
}
} else if (that.goodInfo.displayType == 103) {


if (this.headPrice) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[1].unitExtPrice, ladderPrices[1].sendNumber);
this.changeSendNumber(ladderPrices[1].unitExtPrice.toFixed(2));
} else {

if (this.type == 30) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[1].unitGroupBuyingPrice, ladderPrices[1]
.sendNumber);
this.changeSendNumber(ladderPrices[1].unitGroupBuyingPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[1].unitSalePrice * ladderPrices[1].sendNumber;
this.changeSendNumber(ladderPrices[1].unitSalePrice.toFixed(2));
}
}
} else {
if (ladderPrices[1].unitExtPrice != null) {
that.skuTotalPrice = that.getTotalPrice(ladderPrices[1].unitExtPrice, ladderPrices[1].sendNumber);
this.changeSendNumber(ladderPrices[1].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = ladderPrices[1].salePrice;
this.changeSendNumber(ladderPrices[1].unitSalePrice.toFixed(2));
}
}

}
}
}


that.ladderPrices = ladderPrices; 

that.greenFirst = that.showDtimes[0].date; 
if (this.showDtimes[0].date == "2022-12-19" || this.showDtimes[0].date == "2022-12-26" || this.showDtimes[0]
.date == "2023-01-02") {
Toast({
message: '您的订单有涉及元旦收花调整，1月2日周一自动顺延至1月3日周二。',
duration: 5000,
});
}

that.currentTime = this.nowDate; 

that.deliveryPeriodList = that.goodInfo.deliveryPeriodList; 
that.defultDeliveryPeriod = that.goodInfo.defultDeliveryPeriod; 


that.frequencyCheckcurrent = 0;




} else {





var ruleSkuesArr = that.goods.skus;
ruleSkuesArr = that.dealSpec(ruleSkuesArr);
for (var m = 0; m < ruleSkuesArr.length; m++) {
for (var n = 0; n < ruleSkuesArr[m].models.length; n++) {
ruleSkuesArr[m].models[n].check = false;
}
}
if (ruleSkuesArr.length == 1 && ruleSkuesArr[0].models.length == 1) {
ruleSkuesArr[0].models[0].check = true;

}
that.ruleSkuesArr = ruleSkuesArr;


if (ruleSkuesArr.length == 1 && ruleSkuesArr[0].models.length > 1) {

} else {

that.s_skuId = this.goods.skus[0].skuId;
that.s_skuLadderPriceId = this.goods.skus[0].id != undefined ? this.goods.skus[0].id : 0;
that.s_sendNumber = this.goods.skus[0].sendNumber != undefined ? this.goods.skus[0].sendNumber :
1;
that.s_number = 1;
that.isAuto = this.goods.skus[0].isAutoRenew ? 1 : 0;

that.oldSkuTotalPrice = this.goods.skus[0].salePrice;


if (that.goodInfo.displayType == 102) {
that.skuTotalPrice = (that.skus0.salePrice).toFixed(2);
that.depositTotalPrice = that.getTotalPrice((that.skus0.extPrice + that.skus0.salePrice), 1);

} else if (that.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
that.skuTotalPrice = that.skus0.extPrice;
} else {
that.skuTotalPrice = that.skus0.salePrice;
}
} else if (that.goodInfo.displayType == 103) {


if (this.headPrice) {
that.skuTotalPrice = that.skus0.extPrice;
} else {

if (this.type == 30) {
that.skuTotalPrice = that.skus0.unitGroupBuyingPrice;
} else {
that.skuTotalPrice = that.skus0.salePrice;
}

}
} else {
if (that.skus0.extPrice != null) {
that.skuTotalPrice = this.goods.skus[i].extPrice.toFixed(2);
} else {
that.skuTotalPrice = that.skus0.salePrice;
}
}
}



}

if (this.goodInfo.displayType == 103) {
that.gbpId = this.goodInfo.gbpId; 
}



if (this.goodInfo.displayType == 102) {
validateDiscountPromotion(this.goodInfo.discountPromId, this.vgid).then(res => {
if (res.code == 1) {
if (res.data.status) {
that.isOnGoing = res.data.isOnGoing;
that.haveAppointment = res.data.haveAppointment;
that.buyLimit = res.data.buyLimit;
that.isAppointment = res.data.isAppointment
that.isPreview = res.data.isPreview;


if (that.goods.isCycle) {

if (!that.ladderPrices[0].isAutoRenew) {
if (that.goodInfo.displayType == 104) {

if (that.haveAppointment) {
that.skuTotalPrice = that.getTotalPrice(that.ladderPrices[0].unitExtPrice, that
.ladderPrices[
0].sendNumber);
that.changeSendNumber(that.ladderPrices[0].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = that.ladderPrices[0].salePrice;
that.changeSendNumber(that.ladderPrices[0].unitSalePrice.toFixed(2));
}
}
} else {
if (that.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
that.skuTotalPrice = that.getTotalPrice(that.ladderPrices[1].unitExtPrice, that
.ladderPrices[
1].sendNumber);
that.changeSendNumber(that.ladderPrices[1].unitExtPrice.toFixed(2));
} else {
that.skuTotalPrice = that.ladderPrices[1].salePrice;
that.changeSendNumber(that.ladderPrices[1].unitSalePrice.toFixed(2));
}
}
}
} else {
if (that.goodInfo.displayType == 104) {

if (that.haveAppointment || that.type == 4) {
that.skuTotalPrice = that.skus0.extPrice;
} else {
that.skuTotalPrice = that.skus0.salePrice;
}
}
}


}
}
})
}






if (that.showDtimes.length <= 0) {
that.s_getFlowerDate = 0
} else {
for (let i = 0; i < that.showDtimes.length; i++) {

if (i == 0) {
that.showDtimes[i].check = true;
that.s_getFlowerDate = that.showDtimes[i].date;
}
}
}

this.extraList = JSON.parse(this.goodInfo.extraList); 



let giftList = JSON.parse(this.goodInfo.giftList);
for (let i = 0; i < giftList.length; i++) {

if (giftList[i].stockBalance > 0) {
giftList[i].check = true;
}
}
that.giftList = giftList; 


that.s_getDateType = this.goods.getDateType;

console.log("当前时间-----------", that.showDtimes)





that.currentTime = this.nowDate;



that.cur = that.cuday(this.nowDate);

if (this.goodInfo.payEndTime) {
var presellDate = that.cuday(this.goodInfo.payEndTime);
that.isPresell = 1;
that.presellDate = presellDate;
}




if (this.goodInfo.displayType == 102) {

this.beforeExtraPrice = this.depositTotalPrice;
} else {

this.beforeExtraPrice = this.skuTotalPrice;
this.beforeOldExtraPrice = this.oldSkuTotalPrice;
}


this.flushTime2Gift(0);
},

getSkuMinPrice: function (skuList) {
let sku = []; 
if (this.weChat == false && (this.isGift != true || this.goodInfo.displayType == 102 || this.goodInfo
.displayType ==
103)) {
for (let i = 0; i < skuList.length; i++) {
if (!skuList[i].isAutoRenew) {
sku.push(skuList[i]);
}
}
} else {
sku = skuList;
}



let minIndex = 0;
if (sku[0].unitExtPrice != null) {
for (let i = 0; i < sku.length; i++) {
sku[i]['showPrice'] = this.getTotalPrice(sku[i].unitExtPrice, sku[i].sendNumber);
}
let minShowPrice = Math.min.apply(Math, sku.map((item, index) => {
return item.showPrice
}));
minIndex = sku.findIndex(item => {
return item.showPrice == minShowPrice;
})
} else {
let minSendNumber = Math.min.apply(Math, sku.map((item, index) => {
return item.sendNumber
}));
minIndex = sku.findIndex(item => {
return item.sendNumber == minSendNumber;
})
}

console.log(minIndex)
return sku[minIndex];
},

cuday: function (time) {
var now = new Date(time);
var year = now.getFullYear(); 
var month = now.getMonth(); 
var date = now.getDate(); 
month = month + 1;
if (month < 10) month = "0" + month;
if (date < 10) date = "0" + date;

var times = "";
times = year + "-" + month + "-" + date;
return times;
},


checkLadderPricesFun: function (index, isAutoRenew) {
console.log("index-------", index)
if (isAutoRenew == true && (this.weChat == false || this.cartFlag == 1 || this.goodInfo
.displayType == 102)) {
return; 
}

this.currentindex = index; 

for (let i = 0; i < this.ladderPrices.length; i++) {

if (i == index) {
this.ladderPrices[i].check = true;
this.spec_name = this.ladderPrices[i].name;

this.s_skuId = this.ladderPrices[index].skuId;
this.s_skuLadderPriceId = this.ladderPrices[index].id;
this.s_sendNumber = this.ladderPrices[index].sendNumber;
this.s_number = this.ladderPrices[index].buyNumber;
this.isAuto = this.ladderPrices[index].isAutoRenew ? 1 : 0;
if (this.ladderPrices[index].autoRenewDiscountPrice != null) {
this.skuTotalPrice = this.ladderPrices[index].autoRenewDiscountPrice * this.s_sendNumber;


this.changeSendNumber(this.ladderPrices[index].autoRenewDiscountPrice.toFixed(2), this.ladderPrices[
index].autoRenewDiscountPrice.toFixed(2), this.ladderPrices[index].unitSalePrice.toFixed(2));
} else {

if (this.goodInfo.displayType == 102) {
this.skuTotalPrice = (this.skus0.salePrice * this.ladderPrices[index].sendNumber).toFixed(2);
this.depositTotalPrice = this.getTotalPrice((this.skus0.extPrice + this.skus0.salePrice), this
.ladderPrices[
index]
.sendNumber);
this.changeSendNumber((this.skus0.extPrice + this.skus0.salePrice).toFixed(2));
} else if (this.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
this.skuTotalPrice = this.getTotalPrice(this.ladderPrices[index].unitExtPrice, this.ladderPrices[
index].sendNumber);
this.changeSendNumber(this.ladderPrices[index].unitExtPrice.toFixed(2));
} else {
this.skuTotalPrice = this.ladderPrices[index].salePrice;
this.changeSendNumber(this.ladderPrices[index].unitSalePrice.toFixed(2));
}
} else if (this.goodInfo.displayType == 103) {


if (this.headPrice) {
this.skuTotalPrice = this.getTotalPrice(this.ladderPrices[index].unitExtPrice, this.ladderPrices[
index].sendNumber);
this.changeSendNumber(this.ladderPrices[index].unitExtPrice.toFixed(2));
} else {

if (this.type == 30) {
this.skuTotalPrice = this.getTotalPrice(this.ladderPrices[index].unitGroupBuyingPrice, this
.ladderPrices[
index].sendNumber);
this.changeSendNumber(this.ladderPrices[index].unitGroupBuyingPrice.toFixed(2));
} else {
this.skuTotalPrice = this.ladderPrices[index].unitSalePrice * this.ladderPrices[index].sendNumber;
this.changeSendNumber(this.ladderPrices[index].unitSalePrice.toFixed(2));
}
}
} else {
if (this.ladderPrices[index].unitExtPrice != null) {
this.skuTotalPrice = this.getTotalPrice(this.ladderPrices[index].unitExtPrice, this.ladderPrices[
index].sendNumber);
this.changeSendNumber(this.ladderPrices[index].unitExtPrice.toFixed(2));
} else {
this.skuTotalPrice = this.ladderPrices[index].salePrice;
this.changeSendNumber(this.ladderPrices[index].unitSalePrice.toFixed(2));
}
}

}
this.oldSkuTotalPrice = this.ladderPrices[index].marketPrice;
console.log("this.skuTotalPrice------", this.skuTotalPrice)




} else {
this.ladderPrices[i].check = false;
}

}


if (this.goodInfo.displayType == 102) {

this.beforeExtraPrice = this.depositTotalPrice;
} else {

this.beforeExtraPrice = this.skuTotalPrice;
this.beforeOldExtraPrice = this.oldSkuTotalPrice;

}

this.giftFn(); 
this.extraFn(); 

this.extraCheckPriceFun(); 



this.flushTime2Extra(0);

this.$forceUpdate();
},

changeDateFun: function (index) {
console.log("index-------", index)
console.log("index-------", this.showDtimes)

let checkedDate = this.showDtimes[index].date
if (checkedDate == '2022-12-19' || checkedDate == '2022-12-26' || checkedDate == '2023-01-02') {
Toast({
message: '您的订单有涉及元旦收花调整，1月2日周一自动顺延至1月3日周二。',
duration: 5000,
});
}

for (let i = 0; i < this.showDtimes.length; i++) {

if (i == index) {
this.showDtimes[i]['check'] = true;

this.s_getFlowerDate = this.showDtimes[i].date;
} else {
this.showDtimes[i]['check'] = false;
}
}
this.$forceUpdate();
},

checkExtraFun: function (index) {
console.log("index-------", index)
console.log("this.showExtraList-------", this.showExtraList)

if (this.showExtraList[index].stockBalance < 1) {
return;
}


if (this.cIsNew == this.showExtraList[index].userType) {
this.showExtraList[index].check = !this.showExtraList[index].check;
} else {
if (this.showExtraList[index].userType == 0) {
this.showExtraList[index].check = !this.showExtraList[index].check;
}
}



let total = 0;
let checkExtraList = [];
for (let i = 0; i < this.showExtraList.length; i++) {
if (this.showExtraList[i].check) {
total += Number(this.showExtraList[i].price);
checkExtraList.push(this.showExtraList[i].skuId)

if (this.showExtraList[i].skuType == 1) {
this.isMsg = 1;
}
}
}


if (this.goodInfo.displayType == 102) {
this.depositTotalPrice = parseFloat(this.beforeExtraPrice) + total;
} else {
this.skuTotalPrice = parseFloat(this.beforeExtraPrice) + total;
this.oldSkuTotalPrice = parseFloat(this.beforeOldExtraPrice) + total;
}



this.flushTime2Extra(0);

this.$forceUpdate();


if (this.mayCanPayment) {
this.extraGoodsPrice = total;
this.$store.commit('SET_CHECKEXTRALIST', checkExtraList)
this.getNewOrderPre();
}else{
this.$store.commit('SET_CHECKEXTRALIST', [])
}
},

changeSendNumber: function (textPrice, checkAutoPrice, autoPrice) {
this.textPrice = textPrice;
this.checkAutoPrice = checkAutoPrice;
this.autoPrice = autoPrice;
var text = "",
dpText = "";
if (!!!this.s_sendNumber) { //默认配送一次
this.s_sendNumber = 1;
}
var dp = this.defultDeliveryPeriod;
if (!this.isGift) { //非送礼
if (!!dp) {
if (dp == 7) {
dpText = "每周1期";
} else if (dp == 14) {
dpText = "隔周1期";
} else {
dpText = "每" + dp + "天1期";
}
}
}

if (Number(this.isAuto)) { //自动续订
$('#type').val(0);
$('#discountGoods').val('');

if (checkAutoPrice) {
if (this.s_sendNumber == 1) {
text += "【到期按￥" + autoPrice + "/周续费，可随时取消】";
} else {
if (textPrice != autoPrice) {
text += "【首月￥" + (textPrice * this.s_sendNumber).toFixed(2) + "/月，到期按￥" + (autoPrice * this
.s_sendNumber)
.toFixed(2) + "/月自动续费，可随时取消】";
} else {
text += "【到期按￥" + (autoPrice * this.s_sendNumber).toFixed(2) + "/月续费，可随时取消】";
}
}
} else {
if (this.s_sendNumber == 1) {
text += "【到期按￥" + textPrice + "/周续费，可随时取消】";
} else {
text += "【到期按￥" + (textPrice * this.s_sendNumber).toFixed(2) + "/月续费，可随时取消】";
}
}
} else {
if (this.s_sendNumber > 1) {
if (!this.isGift) {
text += "￥" + textPrice + "/期，" + dpText + "，连续" + this.s_sendNumber + "期";
} else { //送礼
text += "￥" + textPrice + "/期，共" + this.s_sendNumber + "期";
}
} else {
text += "￥" + textPrice + "/期";
}
}

if ((this.gid == 1789 || this.gid == 1799) && this.s_sendNumber == 36) {
this.introduceText = "￥49.75/期，每周1期，连续48期";
} else {
this.introduceText = text;
}
},

closeProductDetail: function () {
this.$emit("closeProductDetail", null)
},

giftFn: function () {
console.log("赠品问题--------------")

var showGiftList = [];
var giftGoodsArr = [];
var gifttypenum = 0;
let transGiftArr = [];

let giftArray = this.giftList;



if (giftArray.length > 0) {
if (this.goods.isCycle) {
var maxstarPeriodgift = 0;
var maxendPeriodgift = 0;
for (var i = 0; i < giftArray.length; i++) {
giftArray[i].check = false;
if (giftArray[i].hasIntervalReward == 1) {
if (giftArray[i].endNumber > maxendPeriodgift) {
maxendPeriodgift = giftArray[i].endNumber;
maxstarPeriodgift = giftArray[i].startNumber;
}
}
}
for (var g = 0; g < giftArray.length; g++) {

if (giftArray[g].hasIntervalReward == 0) {

if (this.goodInfo.ladderPrices[this.currentindex].isAutoRenew == true && (giftArray[g].forType == 1 ||
giftArray[g].forType == 2)) {
showGiftList.push(giftArray[g]);
} else {
if (giftArray[g].forType != 1 && this.goodInfo.ladderPrices[this.currentindex].isAutoRenew !=
true) {
showGiftList.push(giftArray[g]);
}
}
} else {

if (this.goodInfo.ladderPrices[this.currentindex].isAutoRenew == true) {
if (giftArray[g].forType == 1 && giftArray[g].startNumber <= this.goodInfo.ladderPrices[this
.currentindex].sendNumber && giftArray[
g].endNumber >=
this.goodInfo.ladderPrices[this.currentindex].sendNumber) {
showGiftList.push(giftArray[g])
}
} else {
if (giftArray[g].startNumber <= this.goodInfo.ladderPrices[this.currentindex].sendNumber &&
giftArray[
g].endNumber >=
this.goodInfo.ladderPrices[this.currentindex].sendNumber) {
showGiftList.push(giftArray[g])
}
}


}
}




} else {
for (var g = 0; g < giftArray.length; g++) {
if (giftArray[g].hasIntervalReward == 0) {
showGiftList.push(giftArray[g]);
} else {
if (giftArray[g].startNumber <= 1 && giftArray[g].endNumber >= 1) {

showGiftList.push(giftArray[g])
}
}
}

}



for (let j = 0; j < showGiftList.length; j++) {
let temp = showGiftList[j];
if (temp.skuSpecName && temp.skuSpecId) {
if (this.monycheckitem != null) {
if (temp.skuSpecId == this.monycheckitem.skuId) {
transGiftArr.push(temp)
}
}
} else {
transGiftArr.push(temp)
}
}

showGiftList = this.arrayUnique(transGiftArr, 'skuId');

let gifttypenum = 0; 
for (var gi = 0; gi < showGiftList.length; gi++) {
if (showGiftList[gi].userType == 0) {
if (showGiftList[gi].stockBalance > 0) {
var giftGoods = {};
showGiftList[gi].check = true;
giftGoods.pid = showGiftList[gi].aid.toString();
giftGoods.skuId = showGiftList[gi].skuId.toString();
giftGoodsArr.push(giftGoods);
if (showGiftList[gi].skuType == 1) {
gifttypenum++
}
} else {
showGiftList[gi].check = false;
}
} else if (showGiftList[gi].userType == 1) {
if (this.cIsNew == 1) {
if (showGiftList[gi].stockBalance > 0) {
var giftGoods = {};
showGiftList[gi].check = true;
giftGoods.pid = showGiftList[gi].aid.toString();
giftGoods.skuId = showGiftList[gi].skuId.toString()
giftGoodsArr.push(giftGoods);
if (showGiftList[gi].skuType == 1) {
gifttypenum++
}
} else {
showGiftList[gi].check = false;
}
} else {
showGiftList[gi].check = false;
}
} else if (showGiftList[gi].userType == 3) {
if (this.cIsNew == 1 || this.cIsNew == 2) {
if (showGiftList[gi].stockBalance > 0) {
var giftGoods = {};
showGiftList[gi].check = true;
giftGoods.pid = showGiftList[gi].aid.toString();
giftGoods.skuId = showGiftList[gi].skuId.toString()
giftGoodsArr.push(giftGoods);
if (showGiftList[gi].skuType == 1) {
gifttypenum++
}
} else {
showGiftList[gi].check = false;
}
} else {
showGiftList[gi].check = false;
}
}

if (showGiftList[gi].skuType == 1) {
this.isMsg = 1;
}
};



giftGoodsArr = JSON.stringify(giftGoodsArr);
this.showGiftList = showGiftList;
}
},


extraFn: function () {
var showExtraList = [];
let transGiftArr = [];
let extraArray = this.extraList;
if (this.goods.isCycle) {
if (extraArray.length > 0) {
var maxstarPeriod = 0;
var maxendPeriod = 0;
for (var i = 0; i < extraArray.length; i++) {
extraArray[i].check = false;
if (extraArray[i].hasIntervalReward == 1) {
if (extraArray[i].endNumber > maxendPeriod) {
maxendPeriod = extraArray[i].endNumber;
maxstarPeriod = extraArray[i].startNumber;
}
}
}

for (var ex = 0; ex < extraArray.length; ex++) {

if (extraArray[ex].hasIntervalReward == 0) {

if (this.goodInfo.ladderPrices[this.currentindex].isAutoRenew == true && (extraArray[ex].forType ==
1 || extraArray[ex].forType == 2)) {
showExtraList.push(extraArray[ex]);
} else {
if (extraArray[ex].forType != 1 && this.goodInfo.ladderPrices[this.currentindex].isAutoRenew ==
false) {
showExtraList.push(extraArray[ex]);
}
}
} else {

if (this.goodInfo.ladderPrices[this.currentindex].isAutoRenew == true) {
if (extraArray[ex].forType == 1 && extraArray[ex].startNumber <= this.goodInfo.ladderPrices[this
.currentindex].sendNumber &&
extraArray[ex].endNumber >=
this.goodInfo.ladderPrices[this.currentindex].sendNumber) {
showExtraList.push(extraArray[ex])
}
} else {
if (extraArray[ex].startNumber <= this.goodInfo.ladderPrices[this.currentindex].sendNumber &&
extraArray[ex].endNumber >= this.goodInfo.ladderPrices[this.currentindex].sendNumber) {
showExtraList.push(extraArray[ex])
}
}
}
}
}
} else {
for (var ex = 0; ex < extraArray.length; ex++) {
if (extraArray[ex].hasIntervalReward == 0) {
showExtraList.push(extraArray[ex])
} else {
if (extraArray[ex].startNumber <= 1 && extraArray[ex].endNumber >= 1) {
showExtraList.push(extraArray[ex])
}
}
}
};
for (let j = 0; j < showExtraList.length; j++) {
let temp = showExtraList[j];
if (temp.skuSpecName && temp.skuSpecId) {
if (this.monycheckitem != null) {
if (temp.skuSpecId == this.monycheckitem.skuId) {
transGiftArr.push(temp)
}
}
} else {
transGiftArr.push(temp)
}
}
console.log(transGiftArr, 'transGiftArr222')

showExtraList = transGiftArr; 

this.showExtraList = showExtraList;

this.extraDefault();
},


extraDefault: function () {
var defaultArr = [737, 8637];
if (this.mayCanPayment) {
defaultArr = defaultArr.concat(this.checkExtraList)
}

var extraListTemp = this.showExtraList;


extraListTemp.forEach((item, index) => {
defaultArr.forEach((item1, index1) => {
if (item.skuId == item1) {
extraListTemp.splice(index, 1);
extraListTemp.unshift(item);
}
})
});


extraListTemp.forEach((item, index) => {
defaultArr.forEach((item1, index1) => {
if (item.skuId == item1) {
this.checkExtraFun(index)
}
})
});



},

arrayUnique: function (arr, name) {
var hash = {};
return arr.reduce(function (item, next) {
hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
return item;
}, []);
},

dealSpec: function (skus) {
var size = skus.length;
var set = new Set();
for (var i = 0; i < size; i++) {
var specs = skus[i].skuSpecName;
var apecArray = specs.split("|||");
for (var j = 0; j < apecArray.length; j++) {
set.add(apecArray[j].split(":::")[0]);
}
}
var result = [];
for (var x of set) {
var one = {
title: x,
models: []
}
result.push(one)
}
for (var i = 0; i < size; i++) {
var specs = skus[i].skuSpecName;
var apecArray = specs.split("|||");
for (var j = 0; j < apecArray.length; j++) {
var name = apecArray[j].split(":::")[0];
var value = apecArray[j].split(":::")[1];
for (var z = 0; z < result.length; z++) {
var dat = result[z];
if (dat.title == name) {
let obj = {
name: value,
skuid: skus[i].skuId
}
dat.models.push(obj);
}
}
}
}
return result;
},

checmany: function (idx, bigidx, type) {
console.log("this.goods----------", this.goods)
this.checkSpecsIndex = idx;
var faindex = bigidx;
var chindex = idx;
var ruleSkuesArrout = this.ruleSkuesArr;
for (var m = 0; m < ruleSkuesArrout[faindex].models.length; m++) {
ruleSkuesArrout[faindex].models[m].check = false;
}
ruleSkuesArrout[faindex].models[chindex].check = true;
this.specifications_name = ruleSkuesArrout[faindex].models[chindex].name;

var num = this.ruleSkuesArr.length;
var numadd = 0;
var numstr = ''

for (var k = 0; k < ruleSkuesArrout.length; k++) {
for (var v = 0; v < ruleSkuesArrout[k].models.length; v++) {
if (ruleSkuesArrout[k].models[v].check) {
numadd++;
numstr = numstr + '' + ruleSkuesArrout[k].title + ':::' + ruleSkuesArrout[k].models[v].name + '|||'
if (numadd == num) {
numstr = numstr.substring(0, numstr.length - 3);

for (var i = 0; i < this.goods.skus.length; i++) {
if (numstr == this.goods.skus[i].skuSpecName) {
this.monycheckitem = this.goods.skus[i];
this.standard = true;

this.s_skuId = this.goods.skus[i].skuId;
this.s_skuLadderPriceId = this.goods.skus[i].id != undefined ? this.goods.skus[i].id : 0;
this.s_sendNumber = this.goods.skus[i].sendNumber != undefined ? this.goods.skus[i].sendNumber :
1;
this.s_number = 1;
this.isAuto = this.goods.skus[i].isAutoRenew ? 1 : 0;
this.oldSkuTotalPrice = this.goods.skus[i].salePrice;


if (this.goods.isCycle) {

if (this.goodInfo.displayType == 102) {
this.skuTotalPrice = (this.skus0.salePrice).toFixed(2);
this.depositTotalPrice = this.getTotalPrice((this.skus0.extPrice + this.skus0.salePrice),
this.skus0
.sendNumber);
this.changeSendNumber((this.skus0.extPrice + this.skus0.salePrice).toFixed(2));
} else if (this.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
this.skuTotalPrice = this.getTotalPrice(this.goods.skus[i].unitExtPrice, this.goods.skus[i]
.sendNumber);
this.changeSendNumber(this.goods.skus[i].unitExtPrice.toFixed(2));
} else {
this.skuTotalPrice = this.goods.skus[i].salePrice;
this.changeSendNumber(this.goods.skus[i].unitSalePrice.toFixed(2));
}
} else if (this.goodInfo.displayType == 103) {


if (this.headPrice) {
this.skuTotalPrice = this.getTotalPrice(this.goods.skus[i].unitExtPrice, this.goods.skus[i]
.sendNumber);
this.changeSendNumber(this.goods.skus[i].unitExtPrice.toFixed(2));
} else {

if (this.type == 30) {
this.skuTotalPrice = this.getTotalPrice(this.goods.skus[i].unitGroupBuyingPrice, this
.goods
.skus[i].sendNumber);
this.changeSendNumber(this.goods.skus[i].unitGroupBuyingPrice.toFixed(2));
} else {
this.skuTotalPrice = this.goods.skus[i].marketPrice;
this.changeSendNumber(this.goods.skus[i].unitMarketPrice.toFixed(2));
}

}
} else {
if (this.goods.skus[i].unitExtPrice != null) {
this.skuTotalPrice = this.getTotalPrice(this.goods.skus[i].unitExtPrice, this.goods.skus[i]
.sendNumber);
this.changeSendNumber(this.goods.skus[i].unitExtPrice.toFixed(2));
} else {
this.skuTotalPrice = this.goods.skus[i].salePrice;
this.changeSendNumber(this.goods.skus[i].unitSalePrice.toFixed(2));
}
}
} else {


if (this.goodInfo.displayType == 102) {
this.skuTotalPrice = (this.goods.skus[i].salePrice).toFixed(2);
this.depositTotalPrice = this.getTotalPrice((this.goods.skus[i].extPrice + this.goods.skus[i]
.salePrice), 1);
} else if (this.goodInfo.displayType == 104) {

if (this.haveAppointment || this.type == 4) {
this.skuTotalPrice = this.goods.skus[i].extPrice;
} else {
this.skuTotalPrice = this.goods.skus[i].salePrice;
}
} else if (this.goodInfo.displayType == 103) {


if (this.headPrice) {
this.skuTotalPrice = this.goods.skus[i].extPrice;
} else {

if (this.type == 30) {
this.skuTotalPrice = this.goods.skus[i].unitGroupBuyingPrice;
} else {
this.skuTotalPrice = this.goods.skus[i].salePrice;
}

}
} else {
if (this.goods.skus[i].extPrice != null) {
this.skuTotalPrice = this.goods.skus[i].extPrice.toFixed(2);
} else {
this.skuTotalPrice = this.goods.skus[i].salePrice;
}
}

}





if (this.goods.getDateType == 11 || this.goods.getDateType == 12) {
this.s_getFlowerDate = this.showDtimes[0].date;
this.currentTime = this.nowDate; 
} else {
this.s_getFlowerDate = 0
}



if (this.goods.isDayStock) {
var tempdayStock = [];
for (var t = 0; t < this.goods.isDayStock.length; t++) {
var temp = this.goods.isDayStock[t]
if (temp.skuId == this.monycheckitem.skuId) {
tempdayStock.push(temp)
}
}


var dtimesfirst = new Date(this.showDtimes[0].date).valueOf();
var stocknum = 0;
for (var i = 0; i < tempdayStock.length; i++) {
var temptime = new Date(tempdayStock[i].date).valueOf();
if (temptime >= dtimesfirst) {
stocknum += tempdayStock[i].stockBalance
}
}
if (stocknum > 0) {
this.nextstepdisbaled = fasle;
this.day_cal_show = true;
} else {
this.nextstepdisbaled = true;
this.day_cal_show = false
}
this.dayStock = tempdayStock;

} else {
if (this.monycheckitem.stockBalance <= 0) {
this.nextstepdisbaled = true;
} else {
this.nextstepdisbaled = false;
}
}

if (this.groupBuying) {
console.log('pinpin')

var skuIdnew = this.monycheckitem.skuId;
var glist = this.data.productData.groupBuying.gbpItems
console.log(this.data.can, 'this.data.canmnewp')
if (this.data.can == 'newp') {

for (var g = 0; g < glist.length; g++) {
if (glist[g].skuId == skuIdnew) {

this.setData({
monycheckitemgrouping: this.data.productData.groupBuying.gbpItems[g]
})
var newprice = this.data.titlePrice;


if (this.data.productData.groupBuying.hasGroupLeaderPrice && (!this.data.datasharegbId)) {
console.log('fffffffffffff')
if (!newprice.saleprice || newprice.saleprice == 0 || newprice.saleprice == 'NaN.00') {
newprice.saleprice = this.filternum(this.monycheckitemgrouping.groupLeaderPrice -
newprice.presaleprice)
} else {
newprice.saleprice = this.filternum(parseFloat(this.data.titlePrice.saleprice) + this
.monycheckitemgrouping.groupLeaderPrice - newprice.presaleprice)
}
newprice.presaleprice = this.monycheckitemgrouping.groupLeaderPrice;
} else {
console.log('fffffffffffff====================')
if (!newprice.saleprice || newprice.saleprice == 0 || newprice.saleprice == 'NaN.00') {
newprice.saleprice = this.filternum(this.monycheckitemgrouping.groupBuyingPrice -
newprice.presaleprice)
} else {
newprice.saleprice = this.filternum(parseFloat(this.data.titlePrice.saleprice) + this
.monycheckitemgrouping.groupBuyingPrice - newprice.presaleprice)
}
newprice.presaleprice = this.monycheckitemgrouping.groupBuyingPrice;
}

if (!newprice.marketprice || newprice.marketprice == 0) {
newprice.marketprice = this.filternum(this.monycheckitem.salePrice - newprice
.premarketprice);
} else {
newprice.marketprice = this.filternum(parseFloat(this.data.titlePrice.marketprice) +
this.monycheckitem.salePrice - newprice.premarketprice);
}

newprice.premarketprice = this.monycheckitem.salePrice;
this.setData({
titlePrice: newprice,
})
console.log(this.data.titlePrice, 'titlePricetitlePrice2222')
getApp().globalData.gbpId = glist[g].gbpId



}
}
} else { //点击单点按钮
for (var g = 0; g < glist.length; g++) {
if (glist[g].skuId == skuIdnew) {

this.monycheckitem = this.goods.skus[g]
var newprice = this.data.titlePrice;
console.log(newprice, 'newpricenewpricenewprice')
if (newprice.saleprice == '' || newprice.saleprice == 0 || newprice.saleprice ==
'NaN.00') {
newprice.saleprice = this.filternum(this.monycheckitem.salePrice - newprice
.presaleprice)
} else {
newprice.saleprice = this.filternum(parseFloat(newprice.saleprice) + this.monycheckitem
.salePrice - newprice.presaleprice)
}

if (this.monycheckitem.marketPrice) {
newprice.marketprice = this.filternum(parseFloat(this.data.titlePrice.marketprice) +
this.monycheckitem.marketPrice - newprice.premarketprice);
} else {
newprice.marketprice = ''
}
newprice.presaleprice = this.monycheckitem.salePrice;
newprice.premarketprice = this.monycheckitem.marketPrice;
this.setData({
titlePrice: newprice,
})

}
}

}


} else if (this.discountList.length > 0) {

if (this.data.btntextdicount) {
var newprice = this.data.titlePrice;
console.log(newprice)

if (newprice.saleprice == '' || newprice.saleprice == 0) {
newprice.saleprice = this.filternum(parseFloat(this.monycheckitem.salePrice) - newprice
.presaleprice);
} else {
newprice.saleprice = this.filternum(parseFloat(newprice.saleprice) + parseFloat(this
.monycheckitem
.salePrice) - newprice.presaleprice);
}

if (!newprice.marketprice || newprice.marketprice == 0) {
newprice.marketprice = this.filternum(this.monycheckitem.marketPrice - newprice
.premarketprice);
} else {
newprice.marketprice = this.filternum(parseFloat(this.data.titlePrice.marketprice) + this
.monycheckitem
.salePrice - newprice.premarketprice);
}
newprice.presaleprice = this.monycheckitem.salePrice;
newprice.premarketprice = this.monycheckitem.marketPrice;

this.setData({
titlePrice: newprice
})
console.log(this.data.titlePrice, 'titlePricetitlePrice')
} else {
var skuIdnew = this.monycheckitem.skuId;
var dlist = this.data.productData.discountList[0].ruleContent;
for (var d = 0; d < dlist.length; d++) {
if (dlist[d].skuId == skuIdnew) {

this.monycheckitem = this.data.productData.discountList[0].ruleContent[d]
var newprice = this.data.titlePrice;
console.log(this.data.titlePrice, 'newprice')

newprice.saleprice = this.filternum(parseFloat(newprice.saleprice) + this.monycheckitem
.price -
newprice.presaleprice)
newprice.marketprice = this.filternum(parseFloat(newprice.marketprice) + this
.monycheckitem
.salePrice - newprice.premarketprice);
newprice.presaleprice = this.monycheckitem.price;
newprice.premarketprice = this.monycheckitem.salePrice
var discountGoodsother = {};
var discountGoodsotherArr = [];
var discountGoodsotherString = '';
discountGoodsother.pid = this.data.productData.discountList[0].pid.toString();
discountGoodsother.skuId = this.monycheckitem.skuId.toString();
discountGoodsotherArr.push(discountGoodsother);
discountGoodsotherString = JSON.stringify(discountGoodsotherArr);
getApp().globalData.discountGoods = discountGoodsotherString;

this.setData({
titlePrice: newprice,
})

}
}

}

} else if (this.advanceSale) {
var skuIdnew = this.monycheckitem.skuId;

var alist = this.data.productData.advanceSale.advanceSaleItems;

for (var a = 0; a < alist.length; a++) {
if (alist[a].skuId == skuIdnew) {

this.monycheckitem = this.data.productData.advanceSale.advanceSaleItems[a]
var newprice = this.data.titlePrice;

newprice.saleprice = this.filternum(parseFloat(newprice.saleprice) + this.monycheckitem
.depositPrice -
newprice.presaleprice);
newprice.marketprice = this.filternum(parseFloat(this.data.titlePrice.marketprice) + this
.monycheckitem
.depositPrice + this.monycheckitem.retainagePrice - newprice.premarketprice);
newprice.presaleprice = this.monycheckitem.depositPrice;
newprice.premarketprice = this.monycheckitem.depositPrice + this.monycheckitem
.retainagePrice;
this.setData({
titlePrice: newprice,
})

}
}

} else {
var newprice = this.goods;
console.log(newprice)
console.log(this.monycheckitem)
newprice.saleprice = this.filternum(parseFloat(newprice.saleprice) + parseFloat(this
.monycheckitem
.salePrice) - newprice.presaleprice)
if (this.monycheckitem.marketPrice) {
newprice.marketprice = this.filternum(parseFloat(newprice.marketprice) + this.monycheckitem
.marketPrice -
newprice.premarketprice);
} else {
newprice.marketprice = '';
}
newprice.presaleprice = this.monycheckitem.salePrice;
newprice.premarketprice = this.monycheckitem.marketPrice;





}



if (this.goodInfo.displayType == 102) {

this.beforeExtraPrice = this.depositTotalPrice;
} else {

this.beforeExtraPrice = this.skuTotalPrice;
this.beforeOldExtraPrice = this.oldSkuTotalPrice;
}

this.giftFn()
this.extraFn()

}
}
}
}
}
}


this.extraCheckPriceFun();


if(this.mayCanPayment){
this.getNewOrderPre()
}

},

filternum: function (value) {
var value = Math.round(parseFloat(value) * 100) / 100;
var xsd = value.toString().split(".");
if (xsd.length == 1) {
value = value.toString() + ".00";
return value;
}
if (xsd.length > 1) {
if (xsd[1].length < 2) {
value = value.toString() + "0";
}
return value;
}
},


frequencyCheck: function (idx) {
this.frequencyCheckcurrent = idx;
this.defultDeliveryPeriod = this.splitFun(this.deliveryPeriodList[idx], ':', 0);


if (idx == 7) {
this.weektime = "每周";
} else if (idx == 14) {
this.weektime = "隔周";
} else {
this.weektime = "每28天";
}

this.changeSendNumber(this.textPrice, this.checkAutoPrice, this.autoPrice); 
},


openProductImg: function (imgUrl) {
this.$emit('openProductImg', imgUrl);
},


flushTime2Gift: function (flag) {
console.log("计算时间-----------")
if (this.saleableTime2GiftExist) {
if (this.saleableTime2Gift) {


var key = this.gid + '-' + this.s_sendNumber + "-" + (this.isAuto == 1 ? 1 : 0) + "-" + this.cIsNew;
var saleableTime2GiftElement = this.saleableTime2Gift[key];
if (saleableTime2GiftElement && saleableTime2GiftElement.length > 0) {
let nowTimes = [];



let timeStr = "";
for (var j = 0; j < saleableTime2GiftElement.length; j++) {
var needDtime = saleableTime2GiftElement[j];
if (j == 0) {
needDtime['check'] = true;
}

nowTimes.push(needDtime)
timeStr += needDtime.date + '|';
}

this.showDtimes = nowTimes;
this.greenFirst = this.showDtimes[0].date; 
this.currentTime = this.nowDate; 
this.receiveType = 12; 
this.getFlowerDate = timeStr;
this.noSaleableTime = false;
if (flag != 0) {

}
} else if (saleableTime2GiftElement && saleableTime2GiftElement.length == 0) {
this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
} else {


}
} else {
this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
}
} else {

if (flag != null) {


}
}
},


flushTime2Extra: function (flag) {
let checkArr2 = [];

for (let s = 0; s < this.showExtraList.length; s++) {
if (this.showExtraList[s].check) {
checkArr2.push(this.showExtraList[s].skuId);
}
}
if (checkArr2.length == 0) {
this.flushTime2Gift(0);
return;
}


if (this.saleableTime2ExtraExist) {

if (this.saleableTime2Extra) {
var arr = new Array();
var flag = false;
for (var h = 0; h < checkArr2.length; h++) {

var key = checkArr2[h] + '-' + this.s_sendNumber + "-" + (this.isAuto == 1 ? 1 : 0) + "-" + this.cIsNew;
var saleableTime2ExtraElement = this.saleableTime2Extra[key];
if (saleableTime2ExtraElement && saleableTime2ExtraElement.length > 0) {

if (arr.length == 0) {
var key2 = this.gid + '-' + this.s_sendNumber + "-" + (this.isAuto == 1 ? 1 : 0) + "-" + this
.cIsNew;
var saleableTime2GiftElement = this.saleableTime2Gift[key2];
if (saleableTime2GiftElement) {

for (var i = 0; i < saleableTime2ExtraElement.length; i++) {
for (var j = 0; j < saleableTime2GiftElement.length; j++) {
if (saleableTime2ExtraElement[i].date === saleableTime2GiftElement[j].date) {
arr.push(saleableTime2ExtraElement[i])
break;
}
}
}
} else {
for (var j = 0; j < saleableTime2ExtraElement.length; j++) {
arr.push(saleableTime2ExtraElement[j])
}
}
} else {

if (arr.length == 0) {

this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
} else {
var arr2 = new Array();
for (var i = 0; i < saleableTime2ExtraElement.length; i++) {
for (var j = 0; j < arr.length; j++) {
if (saleableTime2ExtraElement[i].date === arr[j].date) {
arr2.push(saleableTime2ExtraElement[i])
break;
}
}
}
arr = arr2;
}
}
} else if (saleableTime2ExtraElement && saleableTime2ExtraElement.length == 0) {
this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
} else {

flag = true;
}
}
if (flag && arr.length == 0) {


return;
}
if (arr.length > 0) {
saleableTime2ExtraElement = arr;
} else {
this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
}




let nowTimes = [];
let timeStr = "";
for (var j = 0; j < saleableTime2ExtraElement.length; j++) {
var needDtime = saleableTime2ExtraElement[j];
if (j == 0) {
needDtime['check'] = true;
}

nowTimes.push(needDtime);
timeStr += needDtime.date + '|';
}
this.showDtimes = nowTimes;
this.greenFirst = this.showDtimes[0].date; 
this.currentTime = this.nowDate; 
this.receiveType = 12; 
this.getFlowerDate = timeStr;
this.receiveType = 12;

if (flag != 0) {

}
} else {

this.$vux.toast.text("当前没有可收花的日期", 'middle');
this.noSaleableTime = true;
return;
}
}
},


extraCheckPriceFun: function () {


let total = 0;
for (let i = 0; i < this.showExtraList.length; i++) {
if (this.showExtraList[i].check) {
total += Number(this.showExtraList[i].price)
}
}


if (this.goodInfo.displayType == 102) {
this.depositTotalPrice = parseFloat(this.beforeExtraPrice) + total;
} else {
this.skuTotalPrice = parseFloat(this.beforeExtraPrice) + total;
this.oldSkuTotalPrice = parseFloat(this.beforeOldExtraPrice) + total;

}

},

getSingleGoodsActivityFun: function (data) {
let activity_type = []; 
let discountList = [],
advanceSale = [],
giftArray = [],
extraArray = [],
groupBuying = [];

if (data.discountList) {
discountList = utils.arrUnique(data.discountList, "pid", "name");
if (data.discountList.length > 0) {
activity_type.push("0");
}
}

if (data.advanceSale) {
advanceSale = [{
aid: data.advanceSale.asId,
name: data.advanceSale.name
}];
activity_type.push("4");
}

if (data.giftArray) {
giftArray = utils.arrUnique(data.giftArray, "aid", "name");
if (data.giftArray.length > 0) {
activity_type.push("2");
}
}

if (data.extraArray) {
extraArray = utils.arrUnique(data.extraArray, "aid", "name");
if (data.extraArray.length > 0) {
activity_type.push("3");
}

}

if (data.groupBuying) {
groupBuying = [{
aid: data.groupBuying.id,
name: data.groupBuying.promotionName
}];
activity_type.push("1");
}

let single_goods_activity = [];
single_goods_activity = single_goods_activity.concat(discountList).concat(advanceSale).concat(giftArray)
.concat(
extraArray).concat(groupBuying);
let single_goods_activity_id = [],
single_goods_activity_name = [];
for (let item in single_goods_activity) {
single_goods_activity_id.push((single_goods_activity[item].aid).toString());
single_goods_activity_name.push(single_goods_activity[item].name);
}
this.single_goods_activity_id = single_goods_activity_id;
this.single_goods_activity_name = single_goods_activity_name;
this.activity_type = activity_type;
},






},
created() {
this.skus0 = this.goods.skus[0];

this.showDtimes = this.dtimes;
this.receiveType = this.goods.getDateType;
this.getFlowerDate = this.goods.getFlowerDate;
this.isAppointDate = this.goods.isAppointDate;
if (this.type == 30 || this.type == 3) {
this.gbid = this.goodInfo.gbid;
}
this.defultDeliveryPeriod = this.goodInfo.defultDeliveryPeriod; 
this.infoFun(); 
this.giftFn(); 
this.extraFn(); 
console.log(this.goodInfo, 'goodInfo')

if (this.goodInfo.goods.cid == 12 && this.goodInfo.displayType != 102 && this.goodInfo.displayType!=103 && !this.goods.goodsExt.moreAddr && this.cartFlag == 0) {
this.mayCanPayment = true
this.getNewOrderPre()
}else{
this.mayCanPayment = false
this.$store.commit('updateAddress',{})
this.$store.commit('SET_GOODSINFO', {})
this.$store.commit('SET_CHECKEXTRALIST', [])
}


},
watch: {
goodInfo() {
if (this.goodInfo) {

}
}
},
filters: {

dateFormat: function (dataStr) {
var time = new Date(dataStr);

function timeAdd0(str) {
if (str < 10) {
str = '0' + str;
}
return str
}
var y = time.getFullYear();
var m = time.getMonth() + 1;
var d = time.getDate();
var h = time.getHours();
var mm = time.getMinutes();
var s = time.getSeconds();
return y + '-' + timeAdd0(m) + '-' + timeAdd0(d);
},
}
}



// WEBPACK FOOTER //
// ./src/components/goodDetail/specsLayer.vue